import { RootState } from 'types'

export default function reduce(state: RootState['headers'] = {}, { type, payload }: any): RootState['headers'] {
  switch (type) {
    case 'HEADERS_SET': {
      const { headers } = payload

      // Do not allow unsetting headers, use HEADERS_UNSET for that
      if (!Object.keys(headers).length) return state

      return { ...headers }
    }
    case 'HEADERS_UNSET': {
      return {}
    }
    default:
      return state
  }
}
